<!-- eslint-disable vue/multi-word-component-names -->
<!--
 * @Description: 左侧悬浮系统菜单栏
 * @Author: PF
 * @Date: 2022-09-13 13:47:02
 * @LastEditors: PF
 * @LastEditTime: 2026-10-09 14:59:10
-->
<template>
  <el-drawer v-model="drawer" direction="ltr" class="menuDrawer" :size="480" :modal="true" :lock-scroll="false" :show-close="false" @close="drawerClose">
    <!-- 头部搜索区 -->
    <template #header>
      <div class="drawer-header">
        <el-cascader placeholder="搜索菜单名称…" v-model="selectedValue" ref="cascaderRef" :options="menuList" :props="{ label: 'cdmc', value: 'id', children: 'children' }" clearable filterable @change="handleCascaderChange" />
        <div class="header-icon" @click="drawerClose">
          <el-icon class="el-icon-menu">
            <CircleCloseFilled />
          </el-icon>
        </div>
      </div>
    </template>

    <!-- 菜单主体 -->
    <div class="menu-body">
      <el-menu :default-active="defaultActive" class="menu-container" :unique-opened="false">
        <!-- 第一列 -->
        <div class="menu-column">
          <template v-for="group in groupList1" :key="group.id">
            <div v-if="menuGroups[group.id].length" class="menu-group">
              <div class="group-title">
                <span class="group-dot" :style="{ background: group.color }"></span>
                <span class="group-text">{{ group.title }}</span>
              </div>
              <el-menu-item v-for="item in menuGroups[group.id]" :key="item.id" :index="String(item.id)" class="menu-item" @click="handleMenuItemClick(item)">
                <span class="item-label">
                  {{ item.cdmc }}
                </span>
              </el-menu-item>
            </div>
          </template>
        </div>

        <!-- 分割线 -->
        <div class="column-divider"></div>

        <!-- 第二列 -->
        <div class="menu-column">
          <template v-for="group in groupList2" :key="group.id">
            <div v-if="menuGroups[group.id].length" class="menu-group">
              <div class="group-title">
                <span class="group-dot" :style="{ background: group.color }"></span>
                <span class="group-text">{{ group.title }}</span>
              </div>
              <el-menu-item v-for="item in menuGroups[group.id]" :key="item.id" :index="String(item.id)" class="menu-item" @click="handleMenuItemClick(item)">
                <span class="item-label">
                  {{ item.cdmc }}
                </span>
              </el-menu-item>
            </div>
          </template>
        </div>
      </el-menu>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, reactive, defineEmits, defineProps, watch } from 'vue'
import { useRouter } from 'vue-router'

// ───────────────────────────── props / emits ─────────────────────────────
const props = defineProps({
  isDrawer: { type: Boolean, required: true },
  row: { type: Object, required: false, default: () => ({}) }
})
const emits = defineEmits(['update:isDrawer'])

// ───────────────────────────── 路由 ─────────────────────────────
const router = useRouter()
// 内部路由用 router.push（不刷新），未注册路由降级为新窗口打开
const safePush = (url) => {
  if (router.resolve(url).matched.length) router.push(url)
  else window.open(url, '_parent')
}

// ───────────────────────────── 常量配置 ─────────────────────────────
/** 菜单分组配置：id 对应 cdlb 值，color 为分组标识色 */
const GROUP_CONFIG = [
  { id: 1, title: '教学应用服务', column: 1, color: '#4F8EF7', sx: 1 },
  { id: 3, title: '管理应用服务', column: 1, color: '#7C5CBF', sx: 2 },
  { id: 8, title: '智能预警服务', column: 2, color: '#E8573A', sx: 3 },
  { id: 5, title: '科研应用服务', column: 1, color: '#0ABF92', sx: 4 },
  { id: 2, title: '决策支持应用服务', column: 2, color: '#F5A623', sx: 5 },
  { id: 4, title: '文化生活应用服务', column: 2, color: '#E94E8A', sx: 6 },
  { id: 7, title: '社会服务', column: 2, color: '#36C5F0', sx: 7 },
  { id: 6, title: '公共服务', column: 2, color: '#9B59B6,', sx: 8 }
]

// ───────────────────────────── 响应式数据 ─────────────────────────────
const defaultActive = ref('0')
const drawer = ref(false)
const userInfo = ref({})

/** 原始菜单树 */
const menuList = ref([])

/** 按 cdlb 分组后的菜单（key = cdlb） */
const menuGroups = reactive({
  1: [],
  2: [],
  3: [],
  4: [],
  5: [],
  6: [],
  7: [],
  8: []
})

/** 级联选择器 */
const selectedValue = ref([])
const cascaderRef = ref(null)

// ───────────────────────────── 计算属性 ─────────────────────────────
const groupList1 = GROUP_CONFIG.filter((g) => g.column === 1)
const groupList2 = GROUP_CONFIG.filter((g) => g.column === 2)

// ───────────────────────────── 方法 ─────────────────────────────

const drawerClose = () => {
  drawer.value = false
  emits('update:isDrawer', false)
}

const initMenuList = () => {
  Object.keys(menuGroups).forEach((key) => {
    menuGroups[key] = []
  })

  const list = props.row?.list || []
  list.forEach((element) => {
    const cdlb = element.cdlb
    if (!element.sfyc && menuGroups[cdlb]) {
      menuGroups[cdlb].push(element)
    }
  })
}

const handleMenuItemClick = (item) => {
  drawerClose()

  if (!item.zjlj) {
    window.open(item.cdlj, '_blank')
    window.open('/', '_self')
  } else {
    safePush(item.cdlj)
  }
}

const handleCascaderChange = () => {
  drawerClose()
  const checkedNodes = cascaderRef.value?.getCheckedNodes() || []
  if (checkedNodes.length === 0) return

  const currentNode = checkedNodes[0]
  const rootNode = currentNode.pathNodes[0]

  // console.log('根节点信息:', rootNode.data)
  // console.log('当前节点信息:', currentNode.data)

  sessionStorage.setItem('CURRENT_SYSTEM_ID', rootNode.data.id)
  safePush(currentNode.data.cdlj)

  selectedValue.value = []
}

// ───────────────────────────── 监听 ─────────────────────────────
watch(
  () => props.isDrawer,
  (val) => {
    if (val) {
      drawer.value = true
      userInfo.value = props.row?.userInfo || {}
      const list = props.row?.list || []
      list.forEach((item) => {
        if (item.zjlj) {
          menuList.value.push(item)
        }
      })
      initMenuList()
    }
  },
  { immediate: true }
)
</script>

<!-- 全局样式（el-drawer 内部结构不在 scoped 内） -->
<style>
/* Drawer 整体外观 */
.el-drawer.menuDrawer {
  background: #f8f9fc !important;
  border-radius: 0 16px 16px 0;
  overflow: hidden;
}

/* 隐藏 drawer 内部所有滚动条 */
.el-drawer.menuDrawer *::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.el-drawer.menuDrawer * {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* Header */
.el-drawer.menuDrawer .el-drawer__header {
  margin-bottom: 0 !important;
  padding: 0 !important;
  border-bottom: none !important;
}

/* 级联选择器宽度 */
.el-drawer.menuDrawer .el-cascader {
  width: 100%;
}
</style>

<!-- 全局样式（el-drawer 内部结构不在 scoped 内） -->
<style>
/* Drawer 整体外观 */
.el-drawer.menuDrawer {
  background: #f8f9fc !important;
  border-radius: 0 16px 16px 0;
  overflow: hidden; /* drawer 外壳仍裁切圆角 */
}
/* drawer 内部主体区域允许滚动 */
.el-drawer.menuDrawer .el-drawer__body {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0 !important;
}
/* ─── 小号滚动条（WebKit：Chrome / Edge / Safari） ─── */
.el-drawer.menuDrawer *::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
}
.el-drawer.menuDrawer *::-webkit-scrollbar-track {
  background: transparent !important;
}
.el-drawer.menuDrawer *::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  transition: background 0.2s;
}
.el-drawer.menuDrawer *::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.28) !important;
}
.el-drawer.menuDrawer *::-webkit-scrollbar-corner {
  background: transparent !important;
}

/* ─── 小号滚动条（Firefox） ─── */
.el-drawer.menuDrawer * {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent !important;
}

/* Header */
.el-drawer.menuDrawer .el-drawer__header {
  margin-bottom: 0 !important;
  padding: 0 !important;
  border-bottom: none !important;
}

/* 级联选择器宽度 */
.el-drawer.menuDrawer .el-cascader {
  width: 100%;
}
</style>
<!-- Scoped 样式 -->
<style lang="less" scoped>
/* ─── Header 区域 ─── */
.drawer-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: linear-gradient(224deg, #4f8ef7 0%, #36c5f0 100%);
  border-radius: 0;

  .header-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #fff;
    }
  }

  :deep(.el-cascader) {
    flex: 1;

    .el-input__wrapper {
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border: none;
      padding: 4px 14px;
      transition: box-shadow 0.25s;

      &:hover,
      &.is-focus {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      }
    }

    .el-input__inner {
      font-size: 14px;
      color: #333;
    }
  }
}

/* ─── Body 区域 ─── */
.menu-body {
  flex: 1;
  overflow: hidden; /* 禁止滚动 */
  padding: 0;
}

.menu-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  overflow: hidden; /* 禁止滚动 */
  border-right: 0;
  background: transparent;
  padding: 16px 0;
}

/* 两列布局 */
.menu-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 12px;
  overflow: hidden; /* 禁止滚动 */
}

/* 分割线 */
.column-divider {
  width: 1px;
  align-self: stretch;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    #dcdfe6 20%,
    #dcdfe6 80%,
    transparent 100%
  );
  margin: 8px 4px;
}

/* ─── 分组 ─── */

.group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;

  .group-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  }

  .group-text {
    font-size: 15px;
    font-weight: 700;
    color: #555;
    letter-spacing: 0.5px;
    text-transform: none;
  }
}

/* ─── 菜单项 ─── */
:deep(.menu-item) {
  height: 34px;
  line-height: 34px;
  padding: 0 12px !important;
  margin: 1px 0;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: transparent !important;

  .el-menu-item {
    background: transparent !important;
  }

  .item-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #4a4a4a;
    cursor: pointer;
    transition: color 0.2s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 16px;

  }

  &:hover {
    background: rgba(79, 142, 247, 0.08) !important;
    transform: translateX(2px);

    .item-label {
      color: #4f8ef7;
    }
  }

  &.is-active {
    background: rgba(79, 142, 247, 0.12) !important;

    .item-label {
      color: #4f8ef7;
      font-weight: 600;
    }
  }
}
</style>
